// extracted by mini-css-extract-plugin
module.exports = {"dictionary__filters":"DictionaryFilters_dictionary__filters__1IpqK"};